export default {
  footerQuickLinks: "Gyors linkek",
  footerAboutRLS: "A RLS-ről",
  footerOurJourney: "Utazásunk",
  footerLeadershipTeam: "Vezetői csapat",
  footerContactUs: "Lépjen kapcsolatba velünk",
  footerConnectWithUs: "Kapcsolódjon hozzánk",
  footerAllRightsReserved: "2025 Refex Life Sciences. Minden jog fenntartva.",
  footerPrivacyPolicy: "Adatvédelmi irányelvek",
  footerTermsOfService: "Szolgáltatási feltételek",
};

